// Inline "Entrar VR" button. Created in JS so we can show/hide based on WebXR support.
// MUST live in the same document as the rendering canvas — see xrManager.ts for why.

import type { XrManager } from '../playcanvas/xrManager';
import { getAnalytics } from '../playcanvas/analytics';

export class VrButton {
  private readonly button: HTMLButtonElement;
  private readonly xr: XrManager;

  constructor(xr: XrManager) {
    this.xr = xr;
    this.button = document.createElement('button');
    this.button.type = 'button';
    this.button.className = 'vr-button';
    this.button.textContent = 'Entrar VR';
    this.button.disabled = true;
    this.button.title = 'Detectando suporte VR…';
    this.button.addEventListener('click', this.onClick);
    document.body.appendChild(this.button);

    this.xr.on((e) => {
      switch (e.type) {
        case 'supported':
          this.button.disabled = false;
          this.button.title = 'Entrar em modo VR (Meta Quest, Pico, etc.)';
          this.button.style.display = '';
          getAnalytics().log('vr_supported');
          break;
        case 'unsupported':
          this.button.disabled = true;
          this.button.title = e.reason ?? 'WebXR não disponível neste dispositivo';
          // Hide the button entirely on devices that can't do VR — desktop without
          // a headset doesn't need the chrome.
          this.button.style.display = 'none';
          getAnalytics().log('vr_unsupported', { reason: e.reason });
          break;
        case 'enter':
          this.button.classList.add('is-active');
          this.button.textContent = 'Sair VR';
          getAnalytics().log('vr_entered');
          break;
        case 'exit':
          this.button.classList.remove('is-active');
          this.button.textContent = 'Entrar VR';
          getAnalytics().log('vr_exited');
          break;
        case 'error':
          console.error('[vrButton] xr error', e.error);
          this.button.textContent = 'Erro VR';
          break;
      }
    });
  }

  private readonly onClick = (): void => {
    if (this.xr.isActive()) {
      this.xr.exit();
    } else {
      this.xr.enter();
    }
  };
}
